import { render, staticRenderFns } from "./KurumBazliRapor.vue?vue&type=template&id=8c374d22"
import script from "./KurumBazliRapor.vue?vue&type=script&lang=js"
export * from "./KurumBazliRapor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports